// NEW_FILE_JUSTIFIED: Utility for downloading base64 data as a file — extracted from GmailPage to stay within 200-line component limit

/** Download base64-encoded data as a file via browser blob */
export function downloadBase64AsFile(base64: string, mimeType: string, filename: string): void {
  const normalized = base64.replace(/-/g, '+').replace(/_/g, '/');
  const byteCharacters = atob(normalized);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
